
import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";

import "./App.scss";

import AppRouter from "./components/AppRouter";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import AccountDashboard from "./components/AccountDashboard/AccountDashboard";

import { getRequisites } from "./actions/header";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRequisites());
  }, [dispatch]);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <BrowserRouter>
          <Header />
        <div className="site-layout">
          <AccountDashboard />
          <AppRouter />
        </div>
          <Footer />
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
